module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pv"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/greenspahnEarly0007#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Frederick E. Greenspahn")]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/greenspahnEarly0008#pt01"
    }
  }, [_vm._v("Part I. Early Diversity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/greenspahnEarly0009#ch01"
    }
  }, [_vm._v("1. The Dead Sea Scrolls")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("James VanderKam")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/greenspahnEarly0010#ch02"
    }
  }, [_vm._v("2. Second Temple Literature outside the Canon")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Martha Himmelfarb")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/greenspahnEarly0011#ch03"
    }
  }, [_vm._v("3. Diaspora and the “Assimilated” Jew")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Erich S. Gruen")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/greenspahnEarly0012#ch04"
    }
  }, [_vm._v("4. Were the Ancient Jews a Nation?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Seth Schwartz")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/greenspahnEarly0013#ch05"
    }
  }, [_vm._v("5. How Christianity Parted from Judaism")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Adele Reinhartz")]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/greenspahnEarly0014#pt02"
    }
  }, [_vm._v("Part II. Emerging Normativity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/greenspahnEarly0015#ch06"
    }
  }, [_vm._v("6. The Emergence of the Synagogue")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Steven Fine")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/greenspahnEarly0016#ch07"
    }
  }, [_vm._v("7. New Directions in Understanding Jewish Liturgy")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Ruth Langer")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/greenspahnEarly0017#ch08"
    }
  }, [_vm._v("8. Ancient Jewish Gender")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Elizabeth Shanks Alexander")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/greenspahnEarly0018#ch09"
    }
  }, [_vm._v("9. Inventing Rabbis")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Christine Hayes")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/greenspahnEarly0019#conc"
    }
  }, [_vm._v("Conclusion: “In My Beginning Is My End”")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Robert Goldenberg")]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/greenspahnEarly0020#ab_contrib"
    }
  }, [_vm._v("About the Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/greenspahnEarly0021#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16aa0a6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/greenspahnEarly-0006.vue
// module id = 69
// module chunks = 0